<div layout="row" flex style="height: 100%" class="sf-leads-container">
    <!-- <div id="leads" flex layout="column" ng-show="$mdMedia('gt-sm') || $state.is('leads')" ng-class="{'full-screen' : !leads.items.length && $state.is('leads') && !search && !isLoading}" -->
    <div id="leads" flex style="height: 100%;" [ngClass]="{ 'desktop-leads': media.isActive('gt-sm') }" layout="column"
        ng-show="$mdMedia('gt-sm') || stateService.is('leads')" class="bg-gray">

        <sfx-toolbar [menuToolbar]="true" class="leads-top-toolbar"
            [ngClass]="{ 'sf-top-toolbar': modelService.me.role.permissions.ced !== 'NONE' }">
            <div class="{'translucent-25': isWalkthroughShowing()}"
                style="justify-content: space-between; display: flex; flex-direction: row;">
                <h1 style="align-self: center" track-id="search" translate>Leads</h1>
                <button *ngIf="!media.isActive('gt-sm')" mat-icon-button (click)="toggleFilterMenu()">
                    <mat-icon fontSet="salesflare" fontIcon="sf-icon-filter" class="icon-22"></mat-icon>
                </button>
            </div>
        </sfx-toolbar>

        <mat-divider *ngIf="media.isActive('gt-sm')"></mat-divider>

        <!-- <div class="container"> -->
        <!-- Here must go the filters -->
        <mat-sidenav-container [ngClass]="{
            'container-desktop': media.isActive('gt-sm'),
            'container-mobile': !media.isActive('gt-sm')
          }">
            <mat-sidenav [ngClass]="{
                    'sidebar-desktop': media.isActive('gt-sm'),
                    'sidebar-mobile': !media.isActive('gt-sm') }" #filtersSidenav
                [mode]="media.isActive('gt-sm') ? 'side' : 'over'"
                [position]="media.isActive('gt-sm') ? 'start' : 'end'" [opened]="media.isActive('gt-sm')"
                class="mat-sidenav-right filters bg-gray">
                <sfx-filters class="bg-gray" (toggleRequested)="filtersSidenav.toggle()" [fixedFilters]="true"
                    [trigger]="trigger$" [entity]="'lead'" [group]="'Lead'" [filters]="filters"
                    [onFilterApply]="boundOnFilterApply" [getDefaultFilters]="getDefaultFilters"
                    [setErrorMessage]="handleFilterError" flex>
                </sfx-filters>
            </mat-sidenav>

            <mat-sidenav-content [ngClass]="{
                'content-desktop': media.isActive('gt-sm'),
                'content-mobile': !media.isActive('gt-sm')
              }" class="bg-gray">
                <sfx-empty-state flex *ngIf="!isLeadFilterApplied() && !leads?.length && !isLoading"
                    image="images/customers_empty.png">
                    <h1 class="accent" *ngIf="media.isActive('gt-sm')" translate>Start filtering to find matching leads.</h1>
                    <h1 class="accent" *ngIf="!media.isActive('gt-sm')"><span translate>Start</span> <a (click)="toggleFilterMenu()" translate>filtering</a> <span translate>to find matching leads.</span></h1>
                </sfx-empty-state>

                <sfx-empty-state flex *ngIf="isLeadFilterApplied() && !leads?.length && !isLoading"
                    image="images/customers_empty.png">
                    <h1 class="accent" translate>No leads match these filters.</h1>
                </sfx-empty-state>

                <div class="content-list sf-empty-state"
                    *ngIf="!isWalkthroughShowing && !leads?.length && isLeadFilterApplied() && !isLoading && usedBadFilter">
                    <img src="../../../../../images/search.png">
                    <h1>{{ badFilterError }}</h1>
                    <h1 translate>Please update the filters to continue.</h1>
                </div>

                <div [ngClass]="{
                    'content-list-desktop': media.isActive('gt-sm'),
                    'content-list-mobile': !media.isActive('gt-sm')
                }" *ngIf="isLeadFilterApplied() && leads?.length">
                    <div *ngIf="media.isActive('gt-sm')" class="leads-list-desktop">
                        <div class="leads-count-desktop">
                            <span *ngIf="numberOfLeads !== undefined" class="secondary">{{ getLeadsCountText() }}</span>
                        </div>
                        <mat-list *ngIf="media.isActive('gt-sm')">
                            <div *ngFor="let lead of leads">
                                <div class="lead-item"
                                    [ngClass]="{
                                        'lead-exists': lead.contacts?.length
                                    }"
                                    data-flex-container>
                                    <div class="lead-info ellipsis" data-flex="1">
                                        <img class="icon-32"
                                            style="border-radius: 50%; object-fit: cover; margin-right: 10px"
                                            [src]="lead.picture">
                                        <span matTooltip="{{ lead.name }}" matTooltipPosition="above"
                                            [class.clickable]="lead.contacts?.length" class="ellipsis primary lead-name"
                                            (click)="lead.contacts?.length && onContactClick(lead.contacts[0].id)">{{
                                            lead.name
                                            }}</span>
                                        <a *ngIf="lead.linkedin_url" [href]="lead.linkedin_url" style="line-height: 0"
                                            target="_blank" rel="noopener">
                                            <img class="icon-14" src="images/applications/linkedin.png" alt="LinkedIn">
                                        </a>
                                    </div>
                                    <span matTooltip="{{ lead.title }}" matTooltipPosition="above"
                                        class="secondary job-title ellipsis" data-flex="1">
                                        {{ lead.title }}
                                    </span>
                                    <!-- <span class="secondary company-name" data-flex="1">{{ lead.company.name }}</span> -->
                                    <div track-id="account" layout="row" class="ellipsis company-name-container"
                                        data-flex="1">
                                        <div [class.clickable]="lead.contacts?.length && lead.linked_account && lead.company?.matching_accounts?.length"
                                            (click)="lead.contacts?.length && lead.linked_account && lead.company?.matching_accounts?.length && goToAccount({ id: lead.company.matching_accounts[0].id }, $event)"
                                            class="ellipsis company-name">
                                            <div #spanRef class="ellipsis"
                                                (mouseenter)="openCompanyMenuIfExists(companyMenuTrigger, spanRef)"
                                                matTooltipPosition="left"
                                                [matMenuTriggerFor]="hasCompanyMenu(lead) ? companyMenu : null"
                                                #companyMenuTrigger="matMenuTrigger"
                                                style="display: flex; align-items: center; text-align: left;">
                                                <img class="icon-22"
                                                    style="border-radius: 50%; object-fit: cover; margin-right: 10px;"
                                                    [src]="getCompanyPicture(lead)"
                                                    [style.visibility]="getCompanyPicture(lead) ? 'inline' : 'hidden'">
                                                <span class="ellipsis secondary">{{
                                                    getCompanyName(lead) }}</span>
                                            </div>
                                            <mat-icon
                                                *ngIf="lead.contacts?.length && lead.linked_account && lead.company?.matching_accounts?.length"
                                                fontSet="salesflare" fontIcon="sf-icon-launch"
                                                class="icon-16 open-account-in-new-tab"
                                                style="margin-left: 8px;"></mat-icon>
                                        </div>

                                        <mat-menu #companyMenu="matMenu" class="no-padding-menu">
                                            <div class="company-menu-content" (click)="$event.stopPropagation()"
                                                (mouseleave)="closeCompanyMenu()">
                                                <div id="account-header">
                                                    <sfx-avatar [src]="getCompanyPicture(lead)"
                                                        class="sf2-avatar_normal"
                                                        style="margin-right: 10px;"></sfx-avatar>
                                                    <h3 *ngIf="lead.linked_account && lead.company?.matching_accounts?.length"
                                                        style="cursor: pointer"
                                                        class="open-account-in-new-tab light-heading"
                                                        (click)="goToAccount({ id: lead.company.matching_accounts[0].id }, $event)">
                                                        {{ lead.company.matching_accounts[0].name }}</h3>
                                                    <h3 *ngIf="!lead.linked_account" class="light-heading">
                                                        {{ lead.company.name }}</h3>
                                                    <a *ngIf="!lead.linked_account && lead.company?.linkedin_url"
                                                        [href]="lead.company.linkedin_url"
                                                        style="line-height: 0; margin-left: 8px" target="_blank"
                                                        rel="noopener">
                                                        <img class="icon-18" src="images/applications/linkedin.png"
                                                            alt="LinkedIn">
                                                    </a>
                                                    <a *ngIf="lead.linked_account && lead.company.matching_accounts?.length && lead.company.matching_accounts[0].social_profiles?.length"
                                                        [href]="getLinkedInUrlFromSocialProfiles(lead.company.matching_accounts[0].social_profiles)"
                                                        style="line-height: 0; margin-left: 8px" target="_blank"
                                                        rel="noopener">
                                                        <img class="icon-18" src="images/applications/linkedin.png"
                                                            alt="LinkedIn">
                                                    </a>
                                                </div>
                                                <mat-divider></mat-divider>
                                                <div id="account-information-section" style="margin-top: 16px">
                                                    <!-- <span class="primary" style="margin-left: 16px; font-weight: bold">Account
                                                    Information</span> -->
                                                    <mat-list *ngIf="!lead.linked_account" style="margin-top: 8px">
                                                        <mat-list-item *ngIf="lead.company?.website"
                                                            class="sf-list-item-info"
                                                            (click)="openWebsite(lead.company.website, $event)">
                                                            <mat-icon class="icon-18 secondary"
                                                                style="margin-right: 16px" fontSet="salesflare"
                                                                fontIcon="sf-icon-website"></mat-icon>
                                                            <span matTooltip="{{ lead.company?.website }}"
                                                                matTooltipPosition="above"
                                                                class="ellipsis secondary website">{{
                                                                lead.company?.website
                                                                }}</span>
                                                        </mat-list-item>

                                                        <!-- If no website found, display default text -->
                                                        <mat-list-item *ngIf="!lead.company?.website"
                                                            class="sf-list-item-info">
                                                            <mat-icon class="icon-18 secondary"
                                                                style="margin-right: 16px" fontSet="salesflare"
                                                                fontIcon="sf-icon-website"></mat-icon>
                                                            <span class="secondary" translate>No website found</span>
                                                        </mat-list-item>

                                                        <!-- Industry -->
                                                        <mat-list-item *ngIf="lead.company?.industry"
                                                            class="sf-list-item-info">
                                                            <mat-icon class="icon-18 secondary"
                                                                style="margin-right: 16px" fontSet="salesflare"
                                                                fontIcon="sf-icon-account-info"></mat-icon>
                                                            <span matTooltip="{{ lead.company?.industry }}"
                                                                matTooltipPosition="above" class="ellipsis secondary">{{
                                                                lead.company?.industry }}</span>
                                                        </mat-list-item>

                                                        <!-- Complete address -->
                                                        <mat-list-item *ngIf="lead.company?.address?.complete_address"
                                                            class="sf-list-item-info">
                                                            <mat-icon class="icon-18 secondary"
                                                                style="margin-right: 16px" fontSet="salesflare"
                                                                fontIcon="sf-icon-address"></mat-icon>
                                                            <span class="secondary limited-width">{{
                                                                lead.company?.address?.complete_address
                                                                }}</span>
                                                        </mat-list-item>

                                                        <!-- Company size -->
                                                        <mat-list-item *ngIf="lead.company?.size"
                                                            class="sf-list-item-info">
                                                            <mat-icon class="icon-18 secondary"
                                                                style="margin-right: 16px" fontSet="salesflare"
                                                                fontIcon="sf-icon-people"></mat-icon>
                                                            <span class="secondary">{{ lead.company?.size | number
                                                                }}</span>
                                                        </mat-list-item>

                                                        <!-- Year founded -->
                                                        <mat-list-item *ngIf="lead.company?.founded"
                                                            class="sf-list-item-info">
                                                            <mat-icon fontSet="salesflare" fontIcon="sf-icon-timeline"
                                                                class="icon-18 secondary"
                                                                style="margin-right: 16px"></mat-icon>
                                                            <span class="secondary">{{ lead.company?.founded }}</span>
                                                        </mat-list-item>
                                                    </mat-list>
                                                    <mat-list
                                                        *ngIf="lead.linked_account && lead.company.matching_accounts?.length"
                                                        style="margin-top: 8px">
                                                        <mat-list-item *ngIf="lead.company.matching_accounts[0].website"
                                                            class="sf-list-item-info"
                                                            (click)="openWebsite(lead.company.matching_accounts[0].website, $event)">
                                                            <mat-icon class="icon-18 secondary"
                                                                style="margin-right: 16px" fontSet="salesflare"
                                                                fontIcon="sf-icon-website"></mat-icon>
                                                            <span
                                                                matTooltip="{{ lead.company.matching_accounts[0].website }}"
                                                                matTooltipPosition="above"
                                                                class="ellipsis secondary website">{{
                                                                lead.company.matching_accounts[0].website
                                                                }}</span>
                                                        </mat-list-item>

                                                        <!-- If no website found, display default text -->
                                                        <mat-list-item
                                                            *ngIf="!lead.company.matching_accounts[0].website"
                                                            class="sf-list-item-info">
                                                            <mat-icon class="icon-18 secondary"
                                                                style="margin-right: 16px" fontSet="salesflare"
                                                                fontIcon="sf-icon-website"></mat-icon>
                                                            <span class="secondary" translate>No website found</span>
                                                        </mat-list-item>

                                                        <!-- Complete address -->
                                                        <mat-list-item
                                                            *ngIf="lead.company?.matching_accounts[0]?.addresses?.length"
                                                            class="sf-list-item-info">
                                                            <mat-icon class="icon-18 secondary"
                                                                style="margin-right: 16px" fontSet="salesflare"
                                                                fontIcon="sf-icon-address"></mat-icon>
                                                            <div fxLayout="column">
                                                                <div *ngFor="let address of lead.company.matching_accounts[0].addresses; let first = first"
                                                                    [ngClass]="{ 'first-address': first, 'address': !first }">
                                                                    <span class="secondary limited-width">{{
                                                                        getCompleteAddress(address) }}</span>
                                                                </div>
                                                            </div>

                                                        </mat-list-item>

                                                        <!-- Company size -->
                                                        <mat-list-item *ngIf="lead.company.matching_accounts[0]?.size"
                                                            class="sf-list-item-info">
                                                            <mat-icon class="icon-18 secondary"
                                                                style="margin-right: 16px" fontSet="salesflare"
                                                                fontIcon="sf-icon-people"></mat-icon>
                                                            <span class="secondary">{{
                                                                lead.company.matching_accounts[0].size | number
                                                                }}</span>
                                                        </mat-list-item>

                                                        <!-- Year founded - taken from lead data -->
                                                        <mat-list-item *ngIf="lead.company?.founded"
                                                            class="sf-list-item-info">
                                                            <mat-icon fontSet="salesflare" fontIcon="sf-icon-timeline"
                                                                class="icon-18 secondary"
                                                                style="margin-right: 16px"></mat-icon>
                                                            <span class="secondary">{{ lead.company?.founded }}</span>
                                                        </mat-list-item>
                                                    </mat-list>
                                                </div>
                                            </div>
                                        </mat-menu>
                                    </div>

                                    <div class="contact-actions-wrapper">
                                        <span *ngIf="!lead.contacts?.length" matTooltip="{{ createButtonTooltipText(lead) }}" [matTooltipDisabled]="!isFindEmailEnabled" matTooltipPosition="above">
                                            <button *ngIf="!isCreatingLead(lead)"
                                                [matMenuTriggerFor]="createLeadMenu"
                                                [disabled]="credits <= 0 || !isFindEmailEnabled || isCreatingLead(lead)"
                                                mat-button color="primary" class="create-btn"><span translate>CREATE</span>
                                            </button>

                                            <mat-progress-spinner class="create-spinner" *ngIf="isCreatingLead(lead)"
                                                mode="indeterminate" [diameter]="24"></mat-progress-spinner>
                                        </span>

                                        <mat-menu #createLeadMenu="matMenu" class="light-blue-font" yPosition="above"
                                            overlapTrigger="true">
                                            <button mat-menu-item *ngFor="let createOption of createOptions"
                                                (click)="confirmCreateAction(lead, createOption.name)">
                                                {{ createOption.display }}
                                            </button>
                                        </mat-menu>

                                        <div class="icon-buttons" *ngIf="lead.contacts?.length">
                                            <div class="menu-hover-wrapper">
                                                <span #spanRef [ngxTippy]="emailTooltipTpl"
                                                    [tippyProps]="{interactive: true, placement: 'top', theme: 'custom', arrow: false}"
                                                    *ngIf="!findingEmails.includes(lead.linkedin_id)" triggers="mouseenter:mouseleave" >
                                                    <button 
                                                        [disabled]="isEmailButtonDisabled(lead)" class="button-32"
                                                        mat-icon-button (click)="onEmailButtonClick(lead, $event)">
                                                        <mat-icon
                                                            [color]="isEmailButtonDisabled(lead) ? 'secondary' : 'primary'"
                                                            class="icon-24" fontSet="salesflare"
                                                            fontIcon="sf-icon-email"></mat-icon>
                                                        <mat-icon *ngIf="!contactExistsAndHasEmail(lead)"
                                                            [color]="isEmailButtonDisabled(lead) ? 'secondary' : 'primary'"
                                                            class="icon-22 overlay-icon" fontSet="salesflare"
                                                            fontIcon="sf-icon-search"></mat-icon>
                                                    </button>
                                                </span>

                                                <ng-template #emailTooltipTpl>
                                                    <div class="tippy-div">
                                                        <span
                                                            [ngClass]="{ 'email-tooltip': !!contactExistsAndHasEmail(lead) }">{{
                                                            getFindEmailTooltip(lead) }}</span>
                                                        <button class="clipboard-button" mat-icon-button *ngIf="!!contactExistsAndHasEmail(lead)"
                                                            (click)="copyEmailToClipboard(lead)">
                                                            <mat-icon class="icon-20" color="primary"
                                                                fontSet="salesflare"
                                                                fontIcon="sf-icon-clipboard"></mat-icon>
                                                        </button>
                                                    </div>
                                                </ng-template>

                                                <mat-progress-spinner class="email-finder-spinner"
                                                    *ngIf="findingEmails.includes(lead.linkedin_id)"
                                                    mode="indeterminate" [diameter]="24"></mat-progress-spinner>
                                            </div>

                                            <span matTooltip="{{ workflowButtonTooltipText(lead) }}">
                                                <button mat-icon-button class="button-32"
                                                    [disabled]="!contactExistsAndHasEmail(lead)"
                                                    (click)="addContactToWorkflow(lead)">
                                                    <mat-icon
                                                        [color]="contactExistsAndHasEmail(lead) ? 'primary' : 'secondary'"
                                                        class="icon-24" fontSet="salesflare"
                                                        fontIcon="sf-icon-workflows"></mat-icon>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </div>
                        </mat-list>
                    </div>

                    <mat-list *ngIf="!media.isActive('gt-sm')" class="leads-list-mobile">
                        <div class="leads-count-mobile">
                            <span *ngIf="numberOfLeads !== undefined" class="secondary">{{ getLeadsCountText() }}</span>
                        </div>
                        <div *ngFor="let lead of leads" class="lead-item"
                            [ngClass]="{
                                'lead-exists': lead.contacts?.length
                            }"
                            data-flex-container>
                            <div class="lead-info" data-flex="1"
                                style="overflow: hidden; text-overflow: ellipsis; display: flex; align-items: center;">
                                <sfx-avatar [src]="lead.picture" class="sf2-avatar_small"
                                    style="margin-right: 10px"></sfx-avatar>

                                <!-- Container for the lead name, linkedin and details below -->
                                <div class="lead-details">
                                    <!-- First row: Lead Name and LinkedIn -->
                                    <div class="lead-name-row">
                                        <span [class.clickable]="lead.contacts?.length" class="primary lead-name"
                                            (click)="lead.contacts?.length && onContactClick(lead.contacts[0].id)">
                                            {{ lead.name }}
                                        </span>
                                        <a *ngIf="lead.linkedin_url" [href]="lead.linkedin_url"
                                            style="line-height: 0; margin-left: 0.5em" target="_blank" rel="noopener">
                                            <img class="icon-14" style="vertical-align: middle; padding-bottom: 3px;"
                                                src="images/applications/linkedin.png" alt="LinkedIn">
                                        </a>
                                    </div>

                                    <div class="lead-subtext" style="display: flex; align-items: left;">
                                        <span class="secondary job-title">{{ lead.position }} {{ lead.company.name ? '@
                                            ' + lead.company.name : '-'
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="contact-actions-wrapper">

                                <span *ngIf="!lead.contacts?.length" matTooltip="{{ createButtonTooltipText(lead) }}"
                                    [matTooltipDisabled]="!isFindEmailEnabled" matTooltipPosition="above">
                                    <button *ngIf="!isCreatingLead(lead)" [matMenuTriggerFor]="createLeadMenu"
                                        [disabled]="credits <= 0 || !isFindEmailEnabled || isCreatingLead(lead)"
                                        mat-button color="primary" class="create-btn"><span translate>CREATE</span>
                                    </button>

                                    <mat-progress-spinner class="create-spinner" *ngIf="isCreatingLead(lead)"
                                        mode="indeterminate" [diameter]="24"></mat-progress-spinner>
                                </span>

                                <mat-menu #createLeadMenu="matMenu" class="light-blue-font" yPosition="above"
                                    overlapTrigger="true">
                                    <button mat-menu-item *ngFor="let createOption of createOptions"
                                        (click)="confirmCreateAction(lead, createOption.name)">
                                        {{ createOption.display }}
                                    </button>
                                </mat-menu>

                                <div class="icon-buttons" *ngIf="lead.contacts?.length">
                                    <div class="menu-hover-wrapper">
                                        <span #spanRef *ngIf="!findingEmails.includes(lead.linkedin_id)">
                                            <button [disabled]="isEmailButtonDisabled(lead)"
                                                [ngxTippy]="emailTooltipTpl"
                                                [tippyProps]="{interactive: true, placement: 'top', theme: 'custom', arrow: false}"
                                                triggers="mouseenter:mouseleave" class="button-32" mat-icon-button
                                                (click)="onEmailButtonClick(lead, $event)">
                                                <mat-icon
                                                    [color]="isEmailButtonDisabled(lead) ? 'secondary' : 'primary'"
                                                    class="icon-24" fontSet="salesflare"
                                                    fontIcon="sf-icon-email"></mat-icon>
                                                <mat-icon *ngIf="!contactExistsAndHasEmail(lead)"
                                                    [color]="isEmailButtonDisabled(lead) ? 'secondary' : 'primary'"
                                                    class="icon-22 overlay-icon" fontSet="salesflare"
                                                    fontIcon="sf-icon-search"></mat-icon>
                                            </button>
                                        </span>

                                        <mat-progress-spinner class="email-finder-spinner"
                                            *ngIf="findingEmails.includes(lead.linkedin_id)" mode="indeterminate"
                                            [diameter]="24"></mat-progress-spinner>

                                        <ng-template #emailTooltipTpl>
                                            <div class="tippy-div">
                                                <span
                                                    [ngClass]="{ 'email-tooltip': !!contactExistsAndHasEmail(lead) }">{{
                                                    getFindEmailTooltip(lead) }}</span>
                                                <button class="clipboard-button" mat-icon-button
                                                    *ngIf="!!contactExistsAndHasEmail(lead)"
                                                    (click)="copyEmailToClipboard(lead)">
                                                    <mat-icon class="icon-20" color="primary" fontSet="salesflare"
                                                        fontIcon="sf-icon-clipboard"></mat-icon>
                                                </button>
                                            </div>
                                        </ng-template>

                                    </div>

                                    <button mat-icon-button class="button-32"
                                        [disabled]="!contactExistsAndHasEmail(lead)"
                                        (click)="addContactToWorkflow(lead)">
                                        <mat-icon [color]="contactExistsAndHasEmail(lead) ? 'primary' : 'secondary'"
                                            class="icon-24" fontSet="salesflare"
                                            fontIcon="sf-icon-workflows"></mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-list>

                    <mat-divider [ngClass]="{
                        'paginator-divider-desktop': media.isActive('gt-sm') }"></mat-divider>

                    <!-- Backend Pagination with Angular Material -->
                    <!-- @ngx-translate: Leads per page -->
                    <mat-paginator [ngClass]="{
                        'paginator-mobile': !media.isActive('gt-sm'),
                        'paginator-desktop': media.isActive('gt-sm') }" [length]="numberOfLeads"
                        [matTooltip]="'Please sign up to explore more leads' | translate"
                        [matTooltipDisabled]="!isTrial()"
                        [pageIndex]="currentPage" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                        [disabled]="isTrial()"
                        (page)="onPageChange($event)">
                    </mat-paginator>
                </div>
            </mat-sidenav-content>

        </mat-sidenav-container>
    </div>
    <div ui-view layout="column" flex></div>
</div>